import { createUseI18n } from '@funtech-int/yango-shared';

import { dictionary } from '../i18n';

export const useI18n = createUseI18n(dictionary);
